import { EntidadesRaw, Entidades } from "./types/entidades";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchEntidades(lang: Locale): Promise<Entidades[]> {
  const res = await fetchWithRetry<{ data: EntidadesRaw[] }>(
    `/instituciones?lang=${cmsLang(lang)}`
  );
  return res.data.map(
    (item): Entidades => ({
      id: item.id,
      nombre: item.nombre,
      imagen: item.foto,
      enlace: item.enlace,
    })
  );
}
